import { AttributeDefinition } from 'domain/experiment/attribute';

export const ATTRIBUTE_LIMIT = 50;

export const EMPTY_PREFILL_ATTRIBUTES: AttributeDefinition[] = [];

export const always: (item: unknown) => boolean = () => true;
